// CRM 2.0 · M12 Template Builder: a yes / no pop-up (one pop-up style: Cancel and the action).
import React, { useState } from "react";
import cls from "./Templates.module.css";

function ConfirmModal({ title, text, action = "Delete", danger = true, onCancel, onConfirm }) {
  const [busy, setBusy] = useState(false);
  async function go() {
    setBusy(true);
    try {
      await onConfirm();
    } finally {
      setBusy(false);
    }
  }
  return (
    <div className={cls.mask} role="dialog" aria-modal="true" aria-label={title}>
      <div className={cls.modal} style={{ maxWidth: "52rem" }}>
        <div className={cls.modalHead}>
          <h2>{title}</h2>
          {text && <p className={cls.hint}>{text}</p>}
        </div>
        <div className={cls.modalFoot}>
          <button className={cls.btn} onClick={onCancel} disabled={busy}>Cancel</button>
          <button className={`${cls.btn} ${danger ? cls.dangerFill : cls.primary}`} onClick={go} disabled={busy}>{busy ? `${action}…` : action}</button>
        </div>
      </div>
    </div>
  );
}

export default ConfirmModal;
